"use client";

import React from "react";

const ApplyingFluoride: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Applying Fluoride: The Different Forms & Processes
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride treatments are quick, painless, and can be applied in various forms during your routine dental check-ups. The most common methods include fluoride foam, gel, or varnish. Each form has its unique advantages, but they all share the same goal – to provide a concentrated dose of fluoride directly to your teeth.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride foam is typically applied using a tray that fits over your teeth. The foam is placed in the tray and left on your teeth for about one to four minutes before being removed. This method allows the fluoride to penetrate deep into the grooves and crevices of your teeth, providing thorough protection.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride gel is usually applied using a small brush or cotton swab. It&rsquo;s painted onto your teeth and left to sit for about one to four minutes before being rinsed off. Some gels may require you to avoid eating or drinking for up to half an hour after the treatment to allow the fluoride to be fully absorbed by your teeth.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride varnish is a newer method that&rsquo;s gaining popularity due to its ease of application and effectiveness. It&rsquo;s painted onto your teeth using a small brush, where it quickly bonds with the tooth enamel, providing long-lasting protection against decay. Varnish treatments can be done in as little as 30 seconds, making them an ideal option for children or those with busy schedules.
      </p>
    </div>
  );
};

export default ApplyingFluoride;